import { createFileRoute } from '@tanstack/react-router';
import { HomeGate } from '@/features/account/shell/HomeGate';
import { ensureOnboardingProgressLoaded } from '@/features/account/onboarding/shared/ensure-onboarding-progress.loader';
import { ResumeBuilderLayout } from '@/features/resume-builder/layout/ResumeBuilderLayout';
import { resumeSearchSchema } from '@/features/resume-builder/shared/resume-search.schema';

/**
 * DEV-483 — o fluxo do currículo aberto pelo PERFIL (`/perfil/curriculo/**`):
 * as MESMAS telas da etapa (EU-761/762) dentro da mesma layout; a origem vem
 * da URL (`useResumeRouteContext`). Sem id de vaga, etapa ou inscrição.
 */
export const Route = createFileRoute('/perfil/curriculo')({
  validateSearch: resumeSearchSchema,
  component: () => (
    <HomeGate>
      <ResumeBuilderLayout />
    </HomeGate>
  ),
  loader: ({ context }) => ensureOnboardingProgressLoaded(context),
});
